import { memo } from 'react';
import { EditableCell } from './EditableCell';
import type { Project } from '@/api/client';
import { getReviewCheckTypeLabel, REVIEW_TABLE_CELL_EMPTY } from '@/utils/reviewCheckType';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

const EmptyValue = () => <span className="projects-table__empty-value">{REVIEW_TABLE_CELL_EMPTY}</span>;

export const ReviewCheckTypeCell = memo(function ReviewCheckTypeCell({
  project,
  searchHighlightWords,
}: {
  project: Project;
  searchHighlightWords?: string[];
}) {
  const text = getReviewCheckTypeLabel(project.review_check_type);
  const display =
    text && searchHighlightWords?.length ? highlightPlainText(text, searchHighlightWords) : text;
  return (
    <EditableCell project={project} fieldKey="review_check_type">
      {text ? <div className="projects-table__base-cell">{display}</div> : <EmptyValue />}
    </EditableCell>
  );
});
